import React, { useEffect, useRef, useState } from 'react';
import DOMPurify from 'dompurify';
const HtmlRenderer = ({ className, style, key, id, htmlContent, tag, isItalic, handleMouseHover, handleMouseLeave, crawling }) => {
    const contentRef = useRef(null);

    if (isItalic === true) {
        const regex = /<i\b[^>]*>/gi;
        htmlContent = htmlContent?.replace(regex, `<i style="font-size: 1.15rem; font-family: 'Sohne-kraftig'">`);
    }

    const sanitizedHtml = DOMPurify.sanitize(htmlContent);
    const Tag = tag ?? 'div';

    return (
        <Tag
            ref={contentRef}
            className={className}
            style={style}
            key={key}
            id={id}
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
    );
};

HtmlRenderer.defaultProps = {
    className: '',
    style: {},
    key: 1,
    id: '',
    htmlContent: '',  // Default should be a string, not an empty JSX element
    tag: 'div',
    isItalic: false,
    crawling: true
};

export default HtmlRenderer;
